import Vue from 'vue';
import Vuex from 'vuex';
import { TreatmentResult } from './TreatmentResult';
import { Links, Publication } from '@/entities/questionaire/Links';

Vue.use(Vuex);

interface State {
  treatments: TreatmentResult[];
  deleteStore: boolean,
  dynamicResultIndex: 0,
  deleteExcludeRecommendations: boolean,
  showCard: boolean,
}

const treatmentResult = {
  state: {
    treatments: [],
    deleteStore: true,
    dynamicResultIndex: 0,
    deleteExcludeRecommendations: false,
    showCard:true,
  } as State, 
  mutations: {
    addTreatment(state: State, treatment: TreatmentResult) { 
      state.treatments.push(treatment);
    },
    setDeleteStore(state: State, value: boolean) {
      state.deleteStore = value;
    },
    setDeleteExcludeRecommendations(state: State, value: boolean) {
      state.deleteExcludeRecommendations = value;
    },
    addNotesToTreatment(state: State, { treatmentId, notes }: { treatmentId: number, notes: string[] }) { 
      const treatment = state.treatments.find(treatment => treatment.id === treatmentId);
      if (treatment) {
        treatment.notes.push(...notes);
      } else {
        // console.error(`Behandlung mit ID ${treatmentId} nicht gefunden.`);
      }
    },
    incrementIndex(state: State) {
      state.dynamicResultIndex ++;
    },
    decrementIndex(state: State) {
      state.dynamicResultIndex --;
    },
    setIndexBegin(state: State) {
      console.log("set Index");
      state.dynamicResultIndex = 0;
    },
    setShowCardComponents(state: State,  value: boolean){
      state.showCard = value;
    },
    clearTreatments(state: State) {
     // this.setIndexBegin;
      console.log("clear Treatments in store");
      state.treatments = [];
      state.dynamicResultIndex = 0;
    },
      updateTreatmentById(state: State, payload: {
        id: number, name: string, percent: number, notes?: string[], possibleTreatments: number, links?: Links , toolBranchId: undefined;
}) {
      let treatment = state.treatments.find(treatment => treatment.id === payload.id);

      if (treatment) {
       
        treatment.id = payload.id;
        treatment.name = payload.name;
        treatment.percent = payload.percent;

        if (payload.notes) {
          treatment.notes = payload.notes;
        }
        treatment.possibleTreatments = payload.possibleTreatments;
        if (payload.links) {
         
          treatment.links = payload.links;
        }
         if (payload.toolBranchId !== undefined) {
      treatment.toolBranchId = payload.toolBranchId; // 👈 ADD THIS
    }


      } else {

        treatment = {
          id: payload.id,
          name: payload.name,
          percent: payload.percent,
          notes: payload.notes || [], 
          possibleTreatments: payload.possibleTreatments,
          links: payload.links || { smpcLink: '', publications: [] }, 
          toolBranchId: payload.toolBranchId 
        };
        state.treatments.push(treatment);
      }
    },

    updateTreatmentNotesById(state: State, payload: { id: number, notes: string[] }) {
      const treatment = state.treatments.find(treatment => treatment.id === payload.id);
      console.log('Payload received:', payload);
      if (treatment) {
        if (!treatment.notes) {
          treatment.notes = []; 
        }
        treatment.notes.push(...payload.notes); 
      } else {
        console.error(`Behandlung Node mit ID ${payload.id} nicht gefunden.`);
      }
    },
    updateDeleteStore({ commit }: { commit: Function }, value: boolean) {
      commit('setDeleteStore', value);
    },
    updateDeleteExcludeRecommendations({ commit }: { commit: Function }, value: boolean) {
      commit('setDeleteExcludeRecommendations', value);
    },
  },
  actions: {
    saveTreatment({ commit }: { commit: Function }, treatment: TreatmentResult) { 
      commit('addTreatment', treatment);
    },
    addNotesToTreatment({ commit }: { commit: Function }, { treatmentId, notes }: { treatmentId: number, notes: string[] }) { 
      commit('addNotesToTreatment', { treatmentId, notes });
    },
    updateTreatmentById({ commit }: { commit: Function }, payload: { id: number, name: string, percent: number, notes?: string[], possibleTreatments: number}) { 
      commit('updateTreatmentById', payload);
    },
    updateTreatmentNotesById({ commit, state }: { commit: Function, state: State }, payload: { id: number, notes: string[] }) {
      const treatment = state.treatments.find(treatment => treatment.id === payload.id);
      if (treatment) {
        treatment.notes = payload.notes; 
      } else {
        console.error(`Behandlung Node mit ID ${payload.id} nicht gefunden.`);
      }
    },
    clearAllTreatments({ commit }: { commit: Function }) {
      commit('clearTreatments');
    },
    updateDeleteStore({ commit }: { commit: Function }, value: boolean) {
      console.log("set store ", value);
      commit('setDeleteStore', value);
    },
    updateDeleteExcludeRecommendation({ commit }: { commit: Function }, value: boolean) {
      commit('setDeleteExcludeRecommendations', value);
    },
    incrementIndex({ commit }: { commit: Function }) {
      commit('incrementIndex');
    },
    decrementIndex({ commit }: { commit: Function }) {
      commit('decrementIndex');
    },
    setIndexBegin({ commit }: { commit: Function }) {
      commit('setIndexBegin');
    },
    setDeleteExcludeRecommendations({ commit }: { commit: Function }, value: boolean) {
      commit('setDeleteExcludeRecommendations');
    },
    setShowCardComponents({ commit }: { commit: Function }, value: boolean) {
      commit('setShowCardComponents', value);
    },
  },
  getters: {
    getTreatmentById: (state: State) => (id: number) => {
      const treatment = state.treatments.find((treatment) => treatment.id === id);
      if (treatment) {
        return {
          ...treatment,
          smpcLink: treatment.links.smpcLink,
          publications: treatment.links.publications,
        };
      }
      return null;
    },
 
    getTreatmentIdByName: (state: State) => (name: string) => {
      const treatment = state.treatments.find((treatment) => treatment.name === name);
      if (treatment) {
        return treatment.id;
      }
      return null;
    },

    getTreatmentByIndex: (state: State) => (index: number) => {
      index = index -1;
      if( index < 0 || index > state.treatments.length) {
        console.log("getTreatmentByIndex Index < 0 or > length");
        return null;
      }
      return state.treatments[index];
    },

    getCurrentTreatment: (state: State) => {
      const currentIndex = state.dynamicResultIndex;

      if( currentIndex < 0 || currentIndex > state.treatments.length) {
        console.log("getCurrentTreatment Index < 0 or > length");
        return null;
      }

      return state.treatments[currentIndex];
    }, 

    getTreatments: (state: State) => {
      return state.treatments;
    }, 

    treatmentResultsCount(state: State) {
      return state.treatments.length;
    },
    getTreatmentsByIndices: (state: State) => (indices: number[]) => {
      return indices.map(index => state.treatments[index]);
    },
    getDeleteStore(state: State) {
      return state.deleteStore;
    },
    getDeleteExcludeRecommendations(state: State) {
      return state.deleteExcludeRecommendations;
    },
    getCurrentIndex(state: State) {
      console.log("current Index ----->",state.dynamicResultIndex )
      return state.dynamicResultIndex;
    },
    getShowCardComponents(state: State){
      return state.showCard;
    }
  },
};

export default treatmentResult;
